/**
 * Page-specific SEO copy (English).
 * Each description opens differently so Google does not reuse the same sitelink snippet.
 * AI News articles use buildNewsArticleDescription() — see newsSeo.js.
 */

export const PAGE_SEO = {
  home: {
    title: 'Malaysia Custom Software & AI Solutions | EWANDS',
    description:
      'EWANDS builds custom software and AI solutions for enterprises across Malaysia, Southeast Asia, China, and the US. Developer-led teams deliver governed AI deployment, integrations, and long-term platform support.',
    keywords:
      'custom software Malaysia, AI solutions Malaysia, AI governance, software developers Malaysia, enterprise AI, Southeast Asia AI, China US AI delivery, governed AI, EWANDS',
  },
  about: {
    title: 'About EWANDS - Software & AI Developers Since 2004',
    description:
      'Meet EWANDS — Malaysia-based developers building custom software and AI solutions since 2004. We partner with teams across Southeast Asia, China, and the US on practical, governed AI delivery.',
    keywords:
      'about EWANDS, custom software developers Malaysia, AI solutions Southeast Asia, software company Malaysia, AI governance team, enterprise AI developers',
  },
  aiGovernance: {
    title: 'AI Governance Malaysia - Responsible AI Framework | ASEAN Aligned',
    description:
      'AI governance for Malaysia and ASEAN — audit trails, human oversight, and compliance aligned with regional ethics guides. EWANDS helps government and enterprise teams deploy AI solutions responsibly.',
    keywords:
      'AI governance Malaysia, responsible AI framework, ASEAN AI governance, AI compliance Malaysia, government AI governance, enterprise AI ethics',
  },
  platform: {
    title: 'Ewands Enterprise AI Platform - Unified Intelligence for Enterprise Operations',
    description:
      'Ewands Enterprise AI Platform unifies fragmented systems, data, and knowledge into one governed layer — powering agents, semantic search, and operational intelligence for enterprise teams.',
    keywords:
      'enterprise AI platform, AI data integration, knowledge graph, AI agents, AI governance, operational intelligence Malaysia',
  },
  applications: {
    title: 'Applications - Custom Software Development Malaysia | EWANDS',
    description:
      'Custom enterprise applications — from classic business software to AI-enabled workflow and knowledge systems — built around how your teams already operate in Malaysia and ASEAN.',
    keywords:
      'custom software development Malaysia, enterprise applications, business application development, workflow automation, AI integration Malaysia',
  },
  capabilities: {
    title: 'AI Capabilities - Predictive AI, Custom Development & AI Agents Malaysia',
    description:
      'Explore EWANDS capabilities: predictive analytics, custom software with AI, agent workflows, sovereign deployment, and implementation advisory for regulated enterprises.',
    keywords:
      'predictive AI Malaysia, custom software AI, AI agents Malaysia, AI implementation, workflow automation, sovereign AI Malaysia',
  },
  aiAgents: {
    title: 'AI Agents Malaysia - Predictive AI, Workflow Automation & Live Data Intelligence',
    description:
      'AI agents for workflow automation, live data analysis, and predictive insight — designed, built, and operated by EWANDS developers for enterprise and governed environments.',
    keywords:
      'AI agents Malaysia, workflow automation AI, predictive AI agents, enterprise AI agents, live data intelligence',
  },
  enterpriseAi: {
    title: 'Enterprise AI Solutions - AI Servers, On-Premise AI & Scalable Infrastructure',
    description:
      'On-premise and hybrid AI infrastructure for mission-critical workloads — AI servers, data sovereignty, and scalable deployment when public cloud is not enough.',
    keywords:
      'enterprise AI Malaysia, AI servers, on-premise AI, hybrid AI infrastructure, data sovereignty AI, mission-critical AI',
  },
  industries: {
    title: 'AI Solutions for Industries - Law Enforcement, Healthcare, Finance & More',
    description:
      'Industry AI solutions for government, healthcare, finance, manufacturing, retail, and facilities — scoped and delivered by EWANDS across Malaysia and Southeast Asia.',
    keywords:
      'industry AI Malaysia, government AI, healthcare AI, fintech AI, manufacturing AI, logistics AI solutions',
  },
  knowledgeHub: {
    title: 'E1 Knowledge Hub - AI Knowledge Base | Semantic Search & AI Chat',
    description:
      'E1 Knowledge Hub turns documents, policies, and research into a searchable AI layer — plain-language Q&A with citations, ready for agents and governed internal chat.',
    keywords:
      'AI knowledge base Malaysia, semantic search enterprise, AI document chat, knowledge management AI, E1 Knowledge Hub',
  },
  e1Analytics: {
    title: 'E1 Analytics, Big Data Predictive Intelligence and Case Tracking',
    description:
      'E1 Analytics applies predictive modelling, pattern recognition, and anomaly detection to operational data — with case tracking and compliance reporting built in.',
    keywords:
      'predictive analytics Malaysia, big data AI, case tracking system, anomaly detection, operational intelligence, E1 Analytics',
  },
  e1DataBridge: {
    title: 'E1 DataBridge - Enterprise Data Integration for AI | CRM, ERP, HRMS',
    description:
      'E1 DataBridge connects CRM, ERP, HRMS, and legacy systems into a governed data layer — structured feeds for AI agents, analytics, and enterprise AI platforms.',
    keywords:
      'enterprise data integration Malaysia, CRM ERP AI integration, HRMS AI, AI data pipeline, E1 DataBridge',
  },
  clientele: {
    title: 'Our Clients - Trusted by Leading Malaysian Enterprises',
    description:
      'EWANDS client portfolio spans government, energy, hospitality, banking, and technology — organizations across Malaysia and the region that rely on our custom software and AI delivery.',
    keywords:
      'EWANDS clients Malaysia, enterprise AI customers, government AI projects, banking AI solutions Malaysia',
  },
  contact: {
    title: 'Contact Us - Get in Touch with EWANDS Malaysia',
    description:
      'Contact EWANDS in Petaling Jaya — speak with our team about AI governance, custom software, and enterprise AI solutions for Malaysia, Southeast Asia, China, or US projects.',
    keywords:
      'contact EWANDS, AI consulting Malaysia, custom software inquiry, Petaling Jaya software company, enterprise AI contact',
  },
  privacyPolicy: {
    title: 'Privacy Policy - EWANDS Data Protection',
    description:
      'EWANDS privacy policy — how we collect, use, store, and protect personal data in line with Malaysian data protection expectations for our software and AI services.',
    keywords:
      'EWANDS privacy policy, data protection Malaysia, AI privacy, personal data handling',
  },
  termsOfUse: {
    title: 'Terms of Use - EWANDS Service Agreement',
    description:
      'EWANDS terms of use — the conditions governing access to our website, software deliverables, AI services, and platform offerings for customers and partners.',
    keywords:
      'EWANDS terms of use, service agreement, AI terms and conditions Malaysia',
  },
  aiNewsHub: {
    title: 'AI News Hub – Frontier AI News & Governance Updates',
    description:
      'EWANDS AI News Hub — sharing curated AI milestones, model launches, and governance shifts with practical notes for developers and enterprise buyers in Southeast Asia.',
    keywords:
      'AI news Malaysia, frontier AI models, AI governance Southeast Asia, enterprise AI developers, EWANDS AI News Hub',
  },
};

/** English uses centralized copy; other languages fall back to i18n seo.* keys. */
export function getPageSeo(pageKey, language, t) {
  if (language === 'en' && PAGE_SEO[pageKey]) {
    return PAGE_SEO[pageKey];
  }
  return {
    title: t('seo.title'),
    description: t('seo.description'),
    keywords: t('seo.keywords'),
  };
}
